import React from "react";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import ColDynamic from "../WrapperComponents/ColDynamic";

import InputComponent from "../../UI/InputComponent/InputComponent";
import WorkAddress from "../WorkAddress/WorkAddress";
import BasicAddressData from "../BasicAddressData/BasicAddressData";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";

const AuditCompanyMember = (props) => {
  const auditCompanyMember = props.parentState.newFormData.auditCompanyMember.find(
    (element) => element.id === props.id
  );

  const arrayLength =
    props.parentState.newFormData.auditCompanyMember.length > 1;

  const { oibValidated } = auditCompanyMember;

  return (
    <>
      <Row>
        <Col>
          <InputComponent
            minLength={11}
            maxLength={11}
            required={props.oibRequired}
            style={
              props.oibRequired &&
              props.required &&
              props.parentState.error &&
              auditCompanyMember.oib.length < 1 &&
              "red"
            }
            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: "auditCompanyMember" }}
            value={auditCompanyMember.oib}
            id={`oib-audit-member${props.id}`}
            name="oib"
            controlLabel="OIB"
          />
          {!oibValidated &&
            auditCompanyMember.oib.length <= 11 &&
            auditCompanyMember.oib.length > 0 && (
              <p style={{ color: "red" }}>Oib nije ispravan!</p>
            )}
        </Col>
        <Col>
          <InputComponent
            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: "auditCompanyMember" }}
            value={auditCompanyMember.prezime}
            id={`prezime-audit-member${props.id}`}
            name="prezime"
            controlLabel="Prezime"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputComponent
            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: "auditCompanyMember" }}
            value={auditCompanyMember.ime}
            id={`ime-audit-member${props.id}`}
            name="ime"
            controlLabel="Ime"
          />
        </Col>
        <Col>
          <InputComponent
            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: "auditCompanyMember" }}
            value={auditCompanyMember.naziv}
            id={`naziv-audit-member${props.id}`}
            name="naziv"
            controlLabel="Naziv društva"
          />
        </Col>
      </Row>
      <BasicAddressData
        required
        hackId="audit-member"
        requiredKbr={props.requiredKbr}
        objData={{ id: props.id, group: "auditCompanyMember" }}
        onChange={props.mappedUserInputHandler}
        address={auditCompanyMember}
        {...props}
      />
      <Row>
        <ColDynamic className="col-lg-4">
          {props.parentState.newFormData.auditCompanyMember.length -1 === props.idZaBtn ?
            <ButtonComponent
              id={`multiply-audit-member-btn${props.id}`}
              onClick={(e) =>
                props.multiplyComponent(e, { formGroup: "auditCompanyMember" })
              }
              >
              Dodaj novi
            </ButtonComponent>
            : null
          }
          
        </ColDynamic>
        <ColDynamic className="col-lg-4">
          {arrayLength && (
            <ButtonComponent
              variant="danger"
              id={`remove-audit-member-btn${props.id}`}
              onClick={(e) =>
                props.removeComponentHandler(e, {
                  formGroup: "auditCompanyMember",
                })
              }
            >
              Ukloni
            </ButtonComponent>
          )}
        </ColDynamic>
      </Row>
    </>
  );
};

export default AuditCompanyMember;
